angular.module('cn')

.component('deletenetwork', {
  controller: [
    '$rootScope',
    '$location',
    'networksRepository',
    function(
      $rootScope,
      $location,
      networksRepository
    ) {

      var $ctrl = this;

      this.$onInit = function() {
        $ctrl.network = $ctrl.resolve.network;
      };

      this.deleteNetwork = function() {
          networksRepository.delete($ctrl.network.id).then(function() {
            $ctrl.close();
            $location.path('/networks');
            $rootScope.$emit('onBackendSuccess', 'Network deleted successfully');
          });
        };
    }
  ],
  template: require('./deletenetwork.html'),
  bindings: {
    resolve: '<',
    close: '&'
  }
});



// WEBPACK FOOTER //
// ./src/cn/deletenetwork.js